/* eslint-disable */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';

import { getStatisticTopics } from '@/store/user-topics/actions';
import { getUserById } from '@/store/users/actions';

import { selectUserTopics } from '@/store/user-topics/selectors';
import { selectUsers } from '@/store/users/selectors';

import { Col, Layout, Row } from 'antd';
import TabsLink from '@/components/TabsLink/TabsLink';

import ColleguesProfileHeader from './ColleguesProfileHeader';

import store from '@/store';

import css from './ColleguesProfile.module.scss';

const { Content } = Layout;

const ColleguesProfile = () => {
  const location = useLocation();
  const { t } = useTranslation('colleaguesProfile');
  const { anotherUser, currentUser } = useSelector(selectUsers);
  const { statistic } = useSelector(selectUserTopics);

  const [placement, setPlacement] = useState(location.pathname.replace(`/collegues/${anotherUser.id}`, '') || '/info');

  return (
    <Content>
      <Row className={css['app-profline__box']}>
        <Col span={24} className={css['app-profline__container']}>
          <div className={css['app-profline__card']}>
            <div>
              <ColleguesProfileHeader user={anotherUser} />
              <TabsLink
                basePage={`/collegues/${anotherUser.id}`}
                isProfile={true}
                placement={placement}
                setPlacement={setPlacement}
                tabsList={[
                  {
                    url: '/info',
                    name: t('information'),
                  },
                  {
                    url: '/recommended',
                    name: t('recommendedToMe'),
                    total: statistic?.recommendation !== 0 ? statistic?.recommendation : '',
                  },
                  {
                    url: '/my-recommendations',
                    name: t('iRecommended'),
                    total: statistic?.recommended !== 0 ? statistic.recommended : '',
                  },
                  {
                    url: '/added',
                    name: t('added'),
                    total: statistic?.created !== 0 ? statistic.created : '',
                  },
                  {
                    url: '/collegues-planning',
                    name: t('plan'),
                  },
                  {
                    url: '/finished',
                    name: t('complete'),
                  },
                ]}
                isAnother
              />
              <div className={css['app-profline__content']}>
                <Outlet
                  user={anotherUser}
                  hasAdditionalInfo={currentUser.domainCompany.hasAdditionalInfo}
                  isAnother
                  noEdit
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Content>
  );
};

const colleguesLoader = async props => {
  await store.dispatch(getUserById(true, props.params.id));
  await store.dispatch(getStatisticTopics(props.params.id));

  return null;
};

export { colleguesLoader };

export default ColleguesProfile;
